import React from "react";
import { Button, Grid, Modal } from "@mui/material";
import { Box } from "@mui/system";

import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";

const UserDeletedModal = ({ modalOpen, handleClose, modalStyle, userData }) => {
  return (
    <Modal open={modalOpen} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Grid>
          <DeleteOutlineRoundedIcon
            style={{ color: "#8E2DE2", width: 50, height: 50 }}
          />
        </Grid>
        <span style={{ color: "#313137", fontSize: 20, fontWeight: 600 }}>
          User Deleted
        </span>
        <Grid container>
          <span
            style={{
              color: "#000000",
              fontSize: 15,
              fontWeight: 500,
              marginTop: 30,
              marginBottom: 30,
            }}
          >
            "
            {userData &&
              `${
                userData.account_type === "Business"
                  ? userData.name && userData.name
                  : userData.first_name &&
                    userData.first_name + " " + userData.last_name &&
                    userData.last_name
              }`}
            ” has been removed from the system successfully.
          </span>
        </Grid>
        <Button
          fullWidth
          variant="contained"
          onClick={handleClose}
          style={{
            width: "200px",
            textTransform: "none",
            height: 55,
            fontSize: 15,
            fontWeight: 600,
            background: "#C84B96",
            color: "#FFFFFF",
          }}
        >
          Okay
        </Button>
      </Box>
    </Modal>
  );
};

export default UserDeletedModal;
